import React, { useEffect, useRef, useState } from "react";
import { useSelector, useDispatch } from "react-redux";
import { Button, DatePicker, Form, Select, Spin, Table } from "antd";
import { ReadCookie } from "../../utils/readCookie";
import numeral from "numeral";
import moment from "moment";
import logo from "../../assets/images/logo.png";
import xlsx from "../../assets/images/ico_xls_sm.gif";
import "../ProducList/productList.css";
import { TabTitle } from "../../utils/GeneralFunction.js";
import { useDownloadExcel } from "react-export-table-to-excel";
import { getDropshipSummary } from "../../redux/actions/dropshipSummaryReports.action.js";
import Swal from "sweetalert2";

const DropshipSummary = ({ token }) => {
  TabTitle("DropShip Summary")
  const userName = ReadCookie("name");
  const dispatch = useDispatch();
  const [form] = Form.useForm();
  const { Option } = Select;
  var date = moment();
  const [loading, setLoading] = useState(false);
  const tableRef = useRef(null);
  const { dropshipSummary } = useSelector((state) => state);
  const [dateTypeId, setDateTypeId] = useState("yte");
  const [monthId, setMonthId] = useState(date.format("MM"));
  const [yearId, setYearId] = useState(date.format("Y"));
  const [currentYearStartDate, setCurrentYearStartDate] = useState(moment().startOf("year").format("MM/DD/YYYY"));
  const [currentYearEndDate, setCurrentYearEndDate] = useState(moment().format("MM/DD/YYYY"));
  const [lastYearStartDate, setLastYearStartDate] = useState(moment().startOf("year").subtract(1, "year").format("MM/DD/YYYY"));
  const [lastYearEndDate, setLastYearEndDate] = useState(moment().subtract(1, "year").format("MM/DD/YYYY"));
  const currentYearStartDateYte = moment().startOf("year").format("MM/DD/YYYY");
  const currentYearEndDateYte = moment().endOf("year").format("MM/DD/YYYY");
  const currentYearEndDateYtd = moment().format("MM/DD/YYYY");
  const lastYearStartDateYte = moment().startOf("year").subtract(1, "year").format("MM/DD/YYYY");
  const lastYearEndDateYte = moment().endOf("year").subtract(1, "year").format("MM/DD/YYYY");
  const lastYearEndDateYtd = moment().subtract(1, "year").format("MM/DD/YYYY");
  const currentYearStartDateMte = monthId + "/" + "01" + "/" + yearId;
  const currentYearEndDateMte = monthId + "/" + moment(`${yearId} / ${monthId}`, "YYYY/MM").daysInMonth() + "/" + yearId;
  const lastYearStartDateMte = monthId + "/" + "01" + "/" + (yearId - 1);
  const lastYearEndDateMte = monthId + "/" + moment(`${yearId - 1} / ${monthId}`, "YYYY/MM").daysInMonth() + "/" + (yearId - 1);
  const [formState, setFormState] = useState({});

  const { onDownload: onDownloadReport } = useDownloadExcel({
    currentTableRef: tableRef.current,
    filename: "Dropship Summary",
    sheet: "Sheet 1",
  });

  const groupedData = dropshipSummary?.payload?.data?.reduce((acc, item) => {
    if (!acc[item.gender_name]) {
      acc[item.gender_name] = [];
    }
    acc[item.gender_name].push(item);
    return acc;
  }, {}) || {};

  // Desired sequence
  const desiredSequence = ["Women", "Men", "Kids"];

  const reorderedData = desiredSequence.reduce((acc, key) => {
    if (groupedData[key]) {
      acc[key] = groupedData[key];
    }
    return acc;
  }, {});

  // useEffect(() => {
  //   let year = yearId;
  //   let month = monthId;
  //   let currentYearStartDate = moment().startOf("year").format("MM/DD/YYYY");
  //   let currentYearEndDate = moment().endOf("year").format("MM/DD/YYYY");
  //   let lastYearStartDate = moment()
  //     .startOf("year")
  //     .subtract(1, "year")
  //     .format("MM/DD/YYYY");
  //   let lastYearEndDate = moment()
  //     .endOf("year")
  //     .subtract(1, "year")
  //     .format("MM/DD/YYYY");

  //   if (dateTypeId === "yte") {
  //     currentYearStartDate = moment().startOf("year").format("MM/DD/") + year;
  //     currentYearEndDate = moment().endOf("year").format("MM/DD/") + year;
  //     lastYearStartDate = moment().startOf("year").subtract(1, "year").format("MM/DD/") + (year - 1);
  //     lastYearEndDate = moment().subtract(1, "year").endOf("year").format("MM/DD/") + (year - 1);
  //   } else if (dateTypeId === "ytd") {
  //     currentYearStartDate = moment().startOf("year").format("MM/DD/") + year;
  //     currentYearEndDate = moment().format("MM/DD/") + year;
  //     lastYearStartDate = moment().startOf("year").subtract(1, "year").format("MM/DD/") + (year - 1);
  //     lastYearEndDate = moment().subtract(1, "year").format("MM/DD/") + (year - 1);
  //   } else if (dateTypeId === "mtd") {
  //     currentYearStartDate = moment().format("MM") + "/" + "01" + "/" + year;
  //     currentYearEndDate = moment().format("MM") + "/" + moment().format("DD") + "/" + year;
  //     lastYearStartDate = moment().format("MM") + "/" + "01" + "/" + (year - 1);
  //     lastYearEndDate = moment().format("MM") + "/" + moment().format("DD") + "/" + (year - 1);
  //   } else if (dateTypeId === "mte") {
  //     currentYearStartDate = month + "/" + "01" + "/" + year;
  //     currentYearEndDate = month + "/" + moment(`${year} / ${month}`, "YYYY/MM").daysInMonth() + "/" + year;
  //     lastYearStartDate = month + "/" + "01" + "/" + (year - 1);
  //     lastYearEndDate = month + "/" + moment(`${year - 1} / ${month}`, "YYYY/MM").daysInMonth() + "/" + (year - 1);
  //   } else if (dateTypeId === "spring") {
  //     currentYearStartDate = "01" + "/" + "01" + "/" + year;
  //     currentYearEndDate = "06" + "/" + "30" + "/" + year;
  //     lastYearStartDate = "01" + "/" + "01" + "/" + (year - 1);
  //     lastYearEndDate = "06" + "/" + "30" + "/" + (year - 1);
  //   } else if (dateTypeId === "fall") {
  //     currentYearStartDate = "07" + "/" + "01" + "/" + year;
  //     currentYearEndDate = "12" + "/" + "31" + "/" + year;
  //     lastYearStartDate = "07" + "/" + "01" + "/" + (year - 1);
  //     lastYearEndDate = "12" + "/" + "31" + "/" + (year - 1);
  //   }
  //   setCurrentYearStartDate(currentYearStartDate);
  //   setCurrentYearEndDate(currentYearEndDate);
  //   setLastYearStartDate(lastYearStartDate);
  //   setLastYearEndDate(lastYearEndDate);

  //   const newState = {
  //     cy_start_date: currentYearStartDate,
  //     cy_end_date: currentYearEndDate,
  //     ly_start_date: lastYearStartDate,
  //     ly_end_date: lastYearEndDate,
  //   };
  //   setFormState(newState);
  // }, [dateTypeId, monthId, yearId]);

  // console.log({ formState })

  // useEffect(() => {
  //   if (dateTypeId === "mtd") {
  //     setMonthId(moment().format("MM"));
  //   }
  // }, [dateTypeId]);

  // console.log({ formState, dateTypeId })


 const onFinish = async () => {
  try {
    setLoading(true);

    const values = await form.validateFields();

    const fromDate = moment(values.from_date);
    const toDate = moment(values.to_date);

    // Check: fromDate should NOT be greater than toDate
    if (fromDate.isAfter(toDate)) {
      setLoading(false);

      Swal.fire({
        icon: "error",
        title: "Oops...",
        text: "From Date cannot be greater than To Date",
      });

      return;
    }

    // (optional) agar equal bhi allow nahi karna:
    // if (fromDate.isSameOrAfter(toDate)) { ... }

    dispatch(getDropshipSummary(token, values)).then((res) => {
      if (res.type === "GET_DROPSHIP_SUMMARY_REPORTS_SUCCESS") {
        setLoading(false);
      }
    });

  } catch (error) {
    setLoading(false);
  }
};

  const handlePrint = () => {
    window.print();
  };

  const columns = [
    {
      title: "#",
      className: "b_bottom",
      render: (text, record, index) => {
        return index + 1
      },
    },
    {
      title: "Customer",
      dataIndex: "customer_name",
      key: "customer_name",
      className: " b_left b_bottom",
      render: (text, record) => {
        return (
          <>
            {text}
          </>
        );
      },
      sorter: (a, b) => {
        return a.customer_name.localeCompare(b.customer_name)
      },
    },
    {
      title: "TY",
      children: [
        {
          title: "SHP U",
          dataIndex: "shipped_qty_cy",
          key: "shipped_qty_cy",
          className: " b_left b_bottom",
          align: "right",
          render: (text, record) => {
            return (
              <>
                {numeral(text).format("0,0")}
              </>
            );
          },
          sorter: (a, b) => {
            return a.shipped_qty_cy - b.shipped_qty_cy
          },
        },
        {
          title: "RTRN U",
          dataIndex: "returned_qty_cy",
          key: "returned_qty_cy",
          className: " b_left b_bottom",
          align: "right",
          render: (text, record) => {
            return (
              <>
                {numeral(text).format("0,0")}
              </>
            );
          },
          sorter: (a, b) => {
            return a.returned_qty_cy - b.returned_qty_cy
          },
        },
        {
          title: "NET U",
          dataIndex: "net_qty_cy",
          key: "net_qty_cy",
          className: " b_left b_bottom",
          align: "right",
          render: (text, record) => {
            return (
              <>
                {numeral(text).format("0,0")}
              </>
            );
          },
          sorter: (a, b) => {
            return a.net_qty_cy - b.net_qty_cy
          },
        },
        {
          title: "SHP $",
          dataIndex: "shipped_amount_cy",
          key: "shipped_amount_cy",
          className: " b_left b_bottom",
          align: "right",
          render: (text, record) => {
            return (
              <>
                $ {numeral(text).format("0,0")}
              </>
            );
          },
          sorter: (a, b) => {
            return a.shipped_amount_cy - b.shipped_amount_cy
          },
        },
        {
          title: "RTRN $",
          dataIndex: "returned_amount_cy",
          key: "returned_amount_cy",
          className: " b_left b_bottom",
          align: "right",
          render: (text, record) => {
            return (
              <>
                $ {numeral(text).format("0,0")}
              </>
            );
          },
          sorter: (a, b) => {
            return a.returned_amount_cy - b.returned_amount_cy
          },
        },
        {
          title: "NET $",
          dataIndex: "net_amount_cy",
          key: "net_amount_cy",
          className: " b_left b_bottom",
          align: "right",
          defaultSortOrder: "descend",
          render: (text, record) => {
            return (
              <>
                $ {numeral(text).format("0,0")}
              </>
            );
          },
          sorter: (a, b) => {
            return a.net_amount_cy - b.net_amount_cy
          },
        },
        {
          title: "AUC",
          dataIndex: "auc_cy",
          key: "auc_cy",
          className: " b_left b_bottom",
          align: "right",
          render: (text, record) => {
            return (
              <>
                {numeral(text).format("0,0")}
              </>
            );
          },
          sorter: (a, b) => {
            return a.auc_cy - b.auc_cy
          },
        },
        {
          title: "RTRN %",
          dataIndex: "ret_rate_per_cy",
          key: "ret_rate_per_cy",
          className: " b_left b_bottom",
          align: "right",
          render: (text, record) => {
            return (
              <>
                {text} %
              </>
            );
          },
          sorter: (a, b) => {
            return a.ret_rate_per_cy - b.ret_rate_per_cy
          },
        },
      ]
    },
    {
      title: "LY",
      children: [
        {
          title: "SHP U",
          dataIndex: "shipped_qty_ly",
          key: "shipped_qty_ly",
          className: " b_left b_bottom",
          align: "right",
          render: (text, record) => {
            return (
              <>
                {numeral(text).format("0,0")}
              </>
            );
          },
          sorter: (a, b) => {
            return a.shipped_qty_ly - b.shipped_qty_ly
          },
        },
        {
          title: "RTRN U",
          dataIndex: "returned_qty_ly",
          key: "returned_qty_ly",
          className: " b_left b_bottom",
          align: "right",
          render: (text, record) => {
            return (
              <>
                {numeral(text).format("0,0")}
              </>
            );
          },
          sorter: (a, b) => {
            return a.returned_qty_ly - b.returned_qty_ly
          },
        },
        {
          title: "NET U",
          dataIndex: "net_qty_ly",
          key: "net_qty_ly",
          className: " b_left b_bottom",
          align: "right",
          render: (text, record) => {
            return (
              <>
                {numeral(text).format("0,0")}
              </>
            );
          },
          sorter: (a, b) => {
            return a.net_qty_ly - b.net_qty_ly
          },
        },
        {
          title: "SHP $",
          dataIndex: "shipped_amount_ly",
          key: "shipped_amount_ly",
          className: " b_left b_bottom",
          align: "right",
          render: (text, record) => {
            return (
              <>
                $ {numeral(text).format("0,0")}
              </>
            );
          },
          sorter: (a, b) => {
            return a.shipped_amount_ly - b.shipped_amount_ly
          },
        },
        {
          title: "RTRN $",
          dataIndex: "returned_amount_ly",
          key: "returned_amount_ly",
          className: " b_left b_bottom",
          align: "right",
          render: (text, record) => {
            return (
              <>
                $ {numeral(text).format("0,0")}
              </>
            );
          },
          sorter: (a, b) => {
            return a.returned_amount_ly - b.returned_amount_ly
          },
        },
        {
          title: "NET $",
          dataIndex: "net_amount_ly",
          key: "net_amount_ly",
          className: " b_left b_bottom",
          align: "right",
          render: (text, record) => {
            return (
              <>
                $ {numeral(text).format("0,0")}
              </>
            );
          },
          sorter: (a, b) => {
            return a.net_amount_ly - b.net_amount_ly
          },
        },
        {
          title: "AUC",
          dataIndex: "auc_ly",
          key: "auc_ly",
          className: " b_left b_bottom",
          align: "right",
          render: (text, record) => {
            return (
              <>
                {numeral(text).format("0,0")}
              </>
            );
          },
          sorter: (a, b) => {
            return a.auc_ly - b.auc_ly
          },
        },
        {
          title: "RTRN %",
          dataIndex: "ret_rate_per_ly",
          key: "ret_rate_per_ly",
          className: " b_left b_bottom",
          align: "right",
          render: (text, record) => {
            return (
              <>
                {text} %
              </>
            );
          },
          sorter: (a, b) => {
            return a.ret_rate_per_ly - b.ret_rate_per_ly
          },
        },
      ]
    },
    {
      title: "TY/LY%",
      className: "b_left b_bottom",
      align: "right",
      render: (text, record) => {
        console.log(
          "ty",
          record.net_amount_ly && record.net_amount_ly !== 0
            ? isFinite(((record.net_amount_cy / record.net_amount_ly - 1) * 100)) &&
              !isNaN(((record.net_amount_cy / record.net_amount_ly - 1) * 100))
              ? numeral(((record.net_amount_cy / record.net_amount_ly - 1) * 100)).format("0,0.00")
              : "0"
            : "0"
        );

        return (
          <>
            {record.net_amount_ly && record.net_amount_ly !== 0
              ? isFinite(((record.net_amount_cy / record.net_amount_ly - 1) * 100)) &&
                !isNaN(((record.net_amount_cy / record.net_amount_ly - 1) * 100))
                ? numeral(((record.net_amount_cy / record.net_amount_ly - 1) * 100)).format("0,0.00")
                : "0"
              : "0"} %
          </>
        );
      },
    }

  ];

  return (
    <>
      <div className="container-fluid">
        <div className="row">
          <div className="col">
            <div className="report-wrapper-main header_class">
              <div className="row justify-content-between pb-0">
                <div className="col-3 d-flex align-items-start  box-space">
                  <div className="logobrand">
                    <img id="ImgLogo" alt="logo" src={logo} />
                  </div>
                </div>

                <div className="col-3 box-space right-content-header text-right">
                  <div className=" d-flex justify-content-end">
                    <div className=" d-flex justify-content-end printing_class">
                      <div className="print_icon printing_class">
                        <i
                          id="Image1"
                          title="Print"
                          alt="Print"
                          className="fa-solid fa-print printing_class"
                          onClick={handlePrint}
                        ></i>
                      </div>
                      <div className="print_icon printing_class">
                        {dropshipSummary?.payload?.data ? (
                          <input
                            type="image"
                            name="ImgExcel"
                            alt="Export to excel"
                            id="ImgExcel"
                            title="Export to excel"
                            src={xlsx}
                            onClick={onDownloadReport}
                            style={{
                              borderWidth: "0px",
                              height: "14px",
                              cursor: "pointer",
                            }}
                          />
                        ) : (
                          <input
                            type="image"
                            name="ImgExcel"
                            alt="Export to excel"
                            id="ImgExcel"
                            title="Export to excel"
                            src={xlsx}
                            style={{ borderWidth: "0px", height: "14px" }}
                          />
                        )}
                      </div>
                    </div>
                    <span style={{ fontWeight: "bolder" }}>
                      Dropship Summary
                      <br />
                      Rpt # 006
                      <br />
                      Login as:
                      <span id="lblSalesPerson" style={{ fontWeight: "bold" }}>
                        {" "}
                        {userName}
                      </span>
                    </span>
                  </div>
                </div>
              </div>
              <div className="row pb-2">
                <div className="col">
                  <Form
                    layout="horizontal"
                    form={form}
                    name="control-hooks"
                    onFinish={onFinish}
                  >
                    <div className="main_form row">
                      <hr className="my-1" />
                      <div className="col-12 col-md-4">
                        <div className=" d-flex flex-row align-items-baseline">
                          <label htmlFor="gender_id" className="labels width30">
                            From Date:
                          </label>
                          <div style={{ marginBottom: "-2px" }} className=" w-100">
                            <Form.Item
                              name="from_date"
                              className="formFullWidth"
                              initialValue={moment().startOf('year')}
                            >
                              <DatePicker
                                size='small'
                                className="styleInput w-100"
                                format={"MM-DD-YYYY"}
                              />
                            </Form.Item>
                          </div>
                        </div>
                      </div>
                      <div className="col-12 col-md-4">
                        <div className=" d-flex flex-row align-items-baseline">
                          <label htmlFor="gender_id" className="labels width30">
                            To Date:
                          </label>
                          <div style={{ marginBottom: "-2px" }} className=" w-100">
                            <Form.Item
                              name="to_date"
                              className="formFullWidth"
                              initialValue={moment().endOf('year')}
                            >
                              <DatePicker
                                size='small'
                                className="styleInput w-100"
                                format={"MM-DD-YYYY"}
                              />
                            </Form.Item>
                          </div>
                        </div>
                      </div>
                      {/* <div className=" col-12 col-md-4">
                        <div className=" d-flex flex-row align-items-baseline">
                          <label htmlFor="gender_id" className="labels width30">
                            Year:
                          </label>
                          <div style={{ marginBottom: "-2px" }} className=" w-100">
                            <DatePicker
                              size="small"
                              className="filter-fields full_date"
                              value={moment(yearId)}
                              defaultValue={moment(yearId)}
                              onChange={(e) =>
                                setYearId(moment(e).format("YYYY"))
                              }
                              picker="year"
                            />
                          </div>
                        </div>
                      </div>
                      <div className=" col-12 col-md-4">
                        <div className=" d-flex flex-row align-items-baseline">
                          <label className="labels width30">Month:</label>
                          <div style={{ marginBottom: "-2px" }} className=" w-100">
                            <DatePicker
                              size="small"
                              className="filter-fields full_date"
                              value={moment(monthId)}
                              disabled={dateTypeId === "ytd"}
                              onChange={(e) =>
                                setMonthId(moment(e).format("MM"))
                              }
                              picker="month"
                              format={"MM"}
                              mode="month"
                            />
                          </div>
                        </div>
                      </div> */}
                      <div className="col-12">
                        <div style={{ marginTop: "3px", display: "flex", justifyContent: "right" }} >
                          <Button type="primary" htmlType="submit" className='submit-btn-btm m-0' disabled={loading}>
                            Search
                          </Button>
                        </div>
                      </div>
                    </div>
                  </Form>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className="table_content"
        style={{ width: '65%' }}
        ref={tableRef} >
        <div>
          {loading ? (
            <div className="d-flex align-items-center justify-content-center spin-style mt-3">
              <Spin />
            </div>
          ) : dropshipSummary?.payload?.data.length ? (
            // Loop through each state group and render a table
            Object.entries(reorderedData).map(([region, data]) => (
              <div key={region} >
                <h3 style={{ borderBottom: "1px solid black", paddingBottom: "1px", display: "inline-block" }}>{region}</h3>
                <Table
                  style={{ fontSize: '10.3px' }}
                  className="test04 mt-3 sales_target_report_table sales_report_res_table sales_target_report_table_dashboard speciality_state"
                  size="small"
                  pagination={false}
                  summary={pageData => {
                    let shipQtyLY = pageData.reduce(function (previousValue, currentValue) {
                      return previousValue += parseFloat(currentValue.shipped_qty_ly)
                    }, 0);
                    let shipAmountLY = pageData.reduce(function (previousValue, currentValue) {
                      return previousValue += parseFloat(currentValue.shipped_amount_ly)
                    }, 0);
                    let returnQtyLY = pageData.reduce(function (previousValue, currentValue) {
                      return previousValue += parseFloat(currentValue.returned_qty_ly)
                    }, 0);
                    let returnAmountLY = pageData.reduce(function (previousValue, currentValue) {
                      return previousValue += parseFloat(currentValue.returned_amount_ly)
                    }, 0);
                    let netQtyLY = pageData.reduce(function (previousValue, currentValue) {
                      return previousValue += parseFloat(currentValue.net_qty_ly)
                    }, 0);
                    let netAmountLY = pageData.reduce(function (previousValue, currentValue) {
                      return previousValue += parseFloat(currentValue.net_amount_ly)
                    }, 0);

                    let shipQtyCY = pageData.reduce(function (previousValue, currentValue) {
                      return previousValue += parseFloat(currentValue.shipped_qty_cy)
                    }, 0);
                    let shipAmountCY = pageData.reduce(function (previousValue, currentValue) {
                      return previousValue += parseFloat(currentValue.shipped_amount_cy)
                    }, 0);
                    let returnQtyCY = pageData.reduce(function (previousValue, currentValue) {
                      return previousValue += parseFloat(currentValue.returned_qty_cy)
                    }, 0);
                    let returnAmountCY = pageData.reduce(function (previousValue, currentValue) {
                      return previousValue += parseFloat(currentValue.returned_amount_cy)
                    }, 0);
                    let netQtyCY = pageData.reduce(function (previousValue, currentValue) {
                      return previousValue += parseFloat(currentValue.net_qty_cy)
                    }, 0);
                    let netAmountCY = pageData.reduce(function (previousValue, currentValue) {
                      return previousValue += parseFloat(currentValue.net_amount_cy)
                    }, 0);
                    return (
                      <>
                        <Table.Summary.Row>
                          <Table.Summary.Cell>
                          </Table.Summary.Cell>
                          <Table.Summary.Cell className="sales_table_summary">
                            <p style={{ fontWeight: "bolder", textAlign: "right" }}>Total</p>
                          </Table.Summary.Cell>
                          <Table.Summary.Cell className="sales_table_summary">
                            <p style={{ fontWeight: "bolder", textAlign: "right", width: "100%", borderTop: "1px solid black", borderBottom: "1px solid black", fontSize: "11.3px" }}>
                              {numeral(shipQtyCY.toLocaleString("en-US")).format("0,00")}
                            </p>
                          </Table.Summary.Cell>
                          <Table.Summary.Cell className="sales_table_summary">
                            <p style={{ fontWeight: "bolder", textAlign: "right", width: "100%", borderTop: "1px solid black", borderBottom: "1px solid black", fontSize: "11.3px" }}>
                              {numeral(returnQtyCY.toLocaleString("en-US")).format("0,00")}
                            </p>
                          </Table.Summary.Cell>
                          <Table.Summary.Cell className="sales_table_summary">
                            <p style={{ fontWeight: "bolder", textAlign: "right", width: "100%", borderTop: "1px solid black", borderBottom: "1px solid black", fontSize: "11.3px" }}>
                              {numeral(netQtyCY.toLocaleString("en-US")).format("0,00")}
                            </p>
                          </Table.Summary.Cell>
                          <Table.Summary.Cell className="sales_table_summary">
                            <p style={{ fontWeight: "bolder", textAlign: "right", width: "100%", borderTop: "1px solid black", borderBottom: "1px solid black", fontSize: "11.3px" }}>
                              $ {numeral(shipAmountCY.toLocaleString("en-US")).format("0,00")}
                            </p>
                          </Table.Summary.Cell>
                          <Table.Summary.Cell className="sales_table_summary">
                            <p style={{ fontWeight: "bolder", textAlign: "right", width: "100%", borderTop: "1px solid black", borderBottom: "1px solid black", fontSize: "11.3px" }}>
                              $ {numeral(returnAmountCY.toLocaleString("en-US")).format("0,00")}
                            </p>
                          </Table.Summary.Cell>
                          <Table.Summary.Cell className="sales_table_summary">
                            <p style={{ fontWeight: "bolder", textAlign: "right", width: "100%", borderTop: "1px solid black", borderBottom: "1px solid black", fontSize: "11.3px" }}>
                              $ {numeral(netAmountCY.toLocaleString("en-US")).format("0,00")}
                            </p>
                          </Table.Summary.Cell>
                          <Table.Summary.Cell className="sales_table_summary">
                            <p style={{ fontWeight: "bolder", textAlign: "right", width: "100%", borderTop: "1px solid black", borderBottom: "1px solid black", fontSize: "11.3px" }}>
                              {numeral((netAmountCY / netQtyCY).toLocaleString("en-US")).format("0,00")}
                            </p>
                          </Table.Summary.Cell>
                          <Table.Summary.Cell className="sales_table_summary">
                            <p style={{ fontWeight: "bolder", textAlign: "right", width: "100%", borderTop: "1px solid black", borderBottom: "1px solid black", fontSize: "11.3px" }}>
                              {numeral(((returnQtyCY / shipQtyCY) * 100).toLocaleString("en-US")).format("0,00")} %
                            </p>
                          </Table.Summary.Cell>
                          <Table.Summary.Cell className="sales_table_summary">
                            <p style={{ fontWeight: "bolder", textAlign: "right", width: "100%", borderTop: "1px solid black", borderBottom: "1px solid black", fontSize: "11.3px" }}>
                              {numeral(shipQtyLY.toLocaleString("en-US")).format("0,00")}
                            </p>
                          </Table.Summary.Cell>
                          <Table.Summary.Cell className="sales_table_summary">
                            <p style={{ fontWeight: "bolder", textAlign: "right", width: "100%", borderTop: "1px solid black", borderBottom: "1px solid black", fontSize: "11.3px" }}>
                              {numeral(returnQtyLY.toLocaleString("en-US")).format("0,00")}
                            </p>
                          </Table.Summary.Cell>
                          <Table.Summary.Cell className="sales_table_summary">
                            <p style={{ fontWeight: "bolder", textAlign: "right", width: "100%", borderTop: "1px solid black", borderBottom: "1px solid black", fontSize: "11.3px" }}>
                              {numeral(netQtyLY.toLocaleString("en-US")).format("0,00")}
                            </p>
                          </Table.Summary.Cell>
                          <Table.Summary.Cell className="sales_table_summary">
                            <p style={{ fontWeight: "bolder", textAlign: "right", width: "100%", borderTop: "1px solid black", borderBottom: "1px solid black", fontSize: "11.3px" }}>
                              $ {numeral(shipAmountLY.toLocaleString("en-US")).format("0,00")}
                            </p>
                          </Table.Summary.Cell>

                          <Table.Summary.Cell className="sales_table_summary">
                            <p style={{ fontWeight: "bolder", textAlign: "right", width: "100%", borderTop: "1px solid black", borderBottom: "1px solid black", fontSize: "11.3px" }}>
                              $ {numeral(returnAmountLY.toLocaleString("en-US")).format("0,00")}
                            </p>
                          </Table.Summary.Cell>
                          <Table.Summary.Cell className="sales_table_summary">
                            <p style={{ fontWeight: "bolder", textAlign: "right", width: "100%", borderTop: "1px solid black", borderBottom: "1px solid black", fontSize: "11.3px" }}>
                              $ {numeral(netAmountLY.toLocaleString("en-US")).format("0,00")}
                            </p>
                          </Table.Summary.Cell>
                          <Table.Summary.Cell className="sales_table_summary">
                            <p style={{ fontWeight: "bolder", textAlign: "right", width: "100%", borderTop: "1px solid black", borderBottom: "1px solid black", fontSize: "11.3px" }}>
                              {numeral((netAmountLY / netQtyLY)).format("0,00")}
                            </p>
                          </Table.Summary.Cell>
                          <Table.Summary.Cell className="sales_table_summary">
                            <p style={{ fontWeight: "bolder", textAlign: "right", width: "100%", borderTop: "1px solid black", borderBottom: "1px solid black", fontSize: "11.3px" }}>
                              {numeral(((returnQtyLY / shipQtyLY) * 100).toLocaleString("en-US")).format("0,00")} %
                            </p>
                          </Table.Summary.Cell>
                          <Table.Summary.Cell className="sales_table_summary">
                            <p style={{ fontWeight: "bolder", textAlign: "right", width: "100%", borderTop: "1px solid black", borderBottom: "1px solid black", fontSize: "11.3px" }}>
                              {numeral((((netAmountCY / netAmountLY) - 1) * 100).toLocaleString("en-US")).format("0.0.00")} %
                            </p>
                          </Table.Summary.Cell>
                        </Table.Summary.Row>
                      </>
                    );
                  }}
                  bordered
                  columns={columns}
                  scroll={{ x: 'max-content' }}
                  dataSource={data}
                />
              </div>
            ))
          ) : (
            <div
              style={{
                backgroundColor: '#CCCCCC',
                borderWidth: '1pt',
                borderStyle: 'Dashed',
                fontWeight: 'bold',
                height: '25px',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
              }}
            >
              No record(s)
            </div>
          )}
        </div>
      </div>
    </>
  );
};

export default DropshipSummary;

